import {
    SEARCH_BOARDS_REQUEST,
    SEARCH_BOARDS_SUCCESS,
    SEARCH_BOARDS_FAILURE,
    FETCH_BOARD_REQUEST,
    FETCH_BOARD_SUCCESS,
    FETCH_BOARD_FAILURE,
    CREATE_BOARD_REQUEST,
    CREATE_BOARD_SUCCESS,
    CREATE_BOARD_FAILURE,
    UPDATE_BOARD_REQUEST,
    UPDATE_BOARD_SUCCESS,
    UPDATE_BOARD_FAILURE,
    DELETE_BOARD_REQUEST,
    DELETE_BOARD_SUCCESS,
    DELETE_BOARD_FAILURE,
    RESET_BOARD_STATE
} from '../actions/board-actions';

const initialState = {
    boards: {
        value: [],
        totalCount: 0,
        page: 0,
        size: 20,
        totalPages: 0
    },
    currentBoard: null,
    loading: false,
    error: null,
    createSuccess: false,
    updateSuccess: false,
    deleteSuccess: false
};

const boardReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_BOARDS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case SEARCH_BOARDS_SUCCESS:
            return {
                ...state,
                loading: false,
                boards: action.payload,
                error: null
            };
        case SEARCH_BOARDS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        case FETCH_BOARD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_BOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                currentBoard: action.payload,
                error: null
            };
        case FETCH_BOARD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        case CREATE_BOARD_REQUEST:
            return {
                ...state,
                loading: true,
                createSuccess: false,
                error: null
            };
        case CREATE_BOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                createSuccess: true,
                currentBoard: action.payload,
                error: null
            };
        case CREATE_BOARD_FAILURE:
            return {
                ...state,
                loading: false,
                createSuccess: false,
                error: action.payload
            };
        
        case UPDATE_BOARD_REQUEST:
            return {
                ...state,
                loading: true,
                updateSuccess: false,
                error: null
            };
        case UPDATE_BOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                updateSuccess: true,
                currentBoard: action.payload,
                error: null
            };
        case UPDATE_BOARD_FAILURE:
            return {
                ...state,
                loading: false,
                updateSuccess: false,
                error: action.payload
            };
        
        case DELETE_BOARD_REQUEST:
            return {
                ...state,
                loading: true,
                deleteSuccess: false,
                error: null
            };
        case DELETE_BOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                deleteSuccess: true,
                boards: {
                    ...state.boards,
                    value: state.boards.value.filter(board => board.id !== action.payload)
                },
                error: null
            };
        case DELETE_BOARD_FAILURE:
            return {
                ...state,
                loading: false,
                deleteSuccess: false,
                error: action.payload
            };
        
        case RESET_BOARD_STATE:
            return {
                ...state,
                createSuccess: false,
                updateSuccess: false,
                deleteSuccess: false,
                error: null
            };
        
        default:
            return state;
    }
};

export default boardReducer;
